import { jsx as t, jsxs as n, Fragment as B } from "react/jsx-runtime";
import { forwardRef as W } from "react";
import { D as z } from "../index-CeQ14xPc.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import { A as S, a as k } from "../Avatar-BG4Ek2lp.js";
import { B as L } from "../Button-CNdjOPcY.js";
import '../OddsButton.css';const q = "320px", O = "600px", w = "1025px", C = "_oddsButton_6qrad_32", N = "_oddsContainer_6qrad_45", v = "_line_6qrad_45", D = "_odds_6qrad_32", I = "_lockedIcon_6qrad_62", M = "_withLine_6qrad_90", A = "_oddsButtonWrapper_6qrad_127", j = "_shouldHideLabelOnMobile_6qrad_138", $ = "_shouldHideLabelOnDesktop_6qrad_151", e = {
  mobile: q,
  "mobile-wide": "480px",
  tablet: O,
  "tablet-wide": "800px",
  desktop: w,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  oddsButton: C,
  oddsContainer: N,
  line: v,
  odds: D,
  lockedIcon: I,
  withLine: M,
  "direction-row": "_direction-row_6qrad_108",
  oddsButtonWrapper: A,
  shouldHideLabelOnMobile: j,
  shouldHideLabelOnDesktop: $
}, F = W(
  ({
    bookieColour: a,
    bookieLogo: r,
    bookieName: s,
    className: h = "",
    flexDirection: y = "column",
    hideBookieLogo: m = !1,
    label: d,
    line: i,
    locked: g = !1,
    odds: f,
    selected: l,
    shouldHideLabelOnDesktop: b = !1,
    shouldHideLabelOnMobile: u = !1,
    wrapperClassName: p = "",
    wrapperStyles: H = {},
    ...x
  }, _) => {
    const c = /* @__PURE__ */ t(
      L,
      {
        className: o(e.oddsButton, h),
        disabled: x.disabled,
        ref: _,
        variant: l ? "secondary" : "default",
        ...x,
        pressed: l,
        title: s,
        children: g ? /* @__PURE__ */ t(z, { className: e.lockedIcon }) : /* @__PURE__ */ n(B, { children: [
          !m && /* @__PURE__ */ t(S, { size: "small", style: { backgroundColor: a }, children: /* @__PURE__ */ t(k, { alt: `${s} logo`, src: r }) }),
          /* @__PURE__ */ n("div", { className: o(e.oddsContainer, e[`direction-${y}`]), children: [
            i && /* @__PURE__ */ t("span", { className: e.line, children: i }),
            /* @__PURE__ */ t("span", { className: o(e.odds, { [e.withLine]: i }), children: f })
          ] })
        ] })
      }
    );
    return d ? /* @__PURE__ */ n(
      "div",
      {
        className: o(
          e.oddsButtonWrapper,
          {
            [e.shouldHideLabelOnDesktop]: b,
            [e.shouldHideLabelOnMobile]: u
          },
          p
        ),
        "data-cxy-name": "odds-button",
        style: H,
        children: [
          /* @__PURE__ */ t("p", { children: d }),
          c
        ]
      }
    ) : c;
  }
);
F.displayName = "OddsButton";
export {
  F as OddsButton
};
